import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Shop {
    constructor() {
        this.slider();
    }

    slider() {
        let s = tns({
            container: '.slider-wrapper .slider'
        });
    }
}